import { List, ListItem, Typography } from 'darrius';

import { MdOutlineChat, MdOutlineCalendarToday } from 'react-icons/md';

import styles from './ProfileShortAbout.module.scss';

import { IGetSummaryReturn } from '../../../modules/profile/shared/pageProps/getSummaryProp/@interfaces';
import { IUserTransformationReturn } from '../../../modules/profile/shared/transformations/user/@interfaces';

interface IProfileAboutProps {
  user: IUserTransformationReturn;
  resume: IGetSummaryReturn;
  partnerProfile: boolean;
  isInstantMatch?: boolean;
}

const partnerIcons = {
  securePayment: {
    url: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/secure-payment.svg`,
    alt: 'Pagamento seguro pela plataforma',
  },
  partneProfile: {
    url: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-profile.svg`,
    alt: 'Parceiro Getninjas',
  },
  iconChecked: {
    url: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/icon-checked.svg`,
    alt: 'Icone de perfil verificado',
  },
};

const icons = {
  message: MdOutlineChat,
  calendar: MdOutlineCalendarToday,
};

export const ProfileShortAbout = ({ user, resume }: IProfileAboutProps) => {
  return (
    <section className={styles.about} id={user.id}>
      <List>
        {resume.badges.map((badge) => {
          const Icon = icons[badge.icon];
          return (
            <ListItem
              className={`${styles['about__list-item']} center-items`}
              key={badge.icon}
            >
              <Icon size={16} />
              <Typography.Text>{badge.text}</Typography.Text>
            </ListItem>
          );
        })}
        {user.partner &&
          user.partner.isPartnerProfile &&
          user.partner.documentationApproved && (
            <>
              <ListItem
                className={`${styles['about__list-item']} center-items`}
              >
                <img
                  className={`${styles['profile-icon-checked']}`}
                  src={partnerIcons.securePayment.url}
                  alt={partnerIcons.securePayment.alt}
                  width="16"
                  height="16"
                />
                <Typography.Text
                  className={`no-margins ${styles['profile-secure-payment']}`}
                >
                  Pagamento <b>seguro</b> pela plataforma
                </Typography.Text>
              </ListItem>
              <ListItem
                className={`${styles['about__list-item']} center-items`}
              >
                <img
                  className={`${styles['profile-icon-checked']}`}
                  src={partnerIcons.partneProfile.url}
                  alt={partnerIcons.partneProfile.alt}
                  width="16"
                  height="16"
                />

                <Typography.Text
                  className={`no-margins ${styles['profile-partner']}`}
                >
                  <b>Parceiro</b> Getninjas
                </Typography.Text>
              </ListItem>
            </>
          )}
        {user.partner &&
          !user.partner.isPartnerProfile &&
          user.partner.documentationApproved && (
            <ListItem className={`${styles['about__list-item']} center-items`}>
              <img
                className={`${styles['profile-icon-checked']}`}
                src={partnerIcons.iconChecked.url}
                alt={partnerIcons.iconChecked.alt}
                width="16"
                height="16"
              />

              <Typography.Text
                className={`no-margins ${styles['profile-secure-payment']}`}
              >
                Identidade <b>verificada</b>
              </Typography.Text>
            </ListItem>
          )}
      </List>
    </section>
  );
};
